export const OVERVIEW_HOME = 'home';
export const OVERVIEW_DETAILS = 'insurance-details';
